import React, { useState } from 'react';
import { Form, Input, Button, Typography, Alert, Result } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import validator from 'validator';

import { sendResetEmail } from '../../reducers/user/resources';

import '../login/AntdLogin.css';

const { Title, Link, Text } = Typography;

const ForgotPassword = ({ history }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [sentToEmail, setSentToEmail] = useState('');

  const onFinish = async ({ email }) => {
    const trimmed = email.trim();
    if (!validator.isEmail(trimmed)) {
      setError('Please enter a valid email address.');
      return;
    }

    setLoading(true);
    setError('');

    try {
      await sendResetEmail({ email: trimmed });
    } catch (err) {
      // Intentionally swallow: confirmation message is shown either way to
      // avoid leaking whether an account exists for the entered email.
    } finally {
      setSentToEmail(trimmed);
      setLoading(false);
    }
  };

  const gotoLogin = () => history.push('/login');

  return (
    <div className="antd-login-card">
      <div className="login-logo-container">
        <a href="#" onClick={(e) => { e.preventDefault(); gotoLogin(); }}>
          <img src="/assets/images/logo.png" alt="GoHire" className="login-card-logo" />
        </a>
      </div>

      {sentToEmail ? (
        <Result
          status="success"
          title="Check your email"
          subTitle={`If a matching account was found, an email will be sent to ${sentToEmail} to allow you to reset your password.`}
          extra={(
            <Button type="primary" className="login-form-button" onClick={gotoLogin} block>
              BACK TO LOGIN
            </Button>
          )}
        />
      ) : (
        <Form
          form={form}
          name="forgot-password"
          onFinish={onFinish}
          layout="vertical"
          size="large"
          requiredMark={false}
        >
          <div className="login-header">
            <Title level={2} className="login-title">Forgot Password</Title>
            <Text type="secondary">
              Enter your email address and we&apos;ll send you a link to reset your password.
            </Text>
          </div>

          <Form.Item
            name="email"
            rules={[{ required: true, message: 'Please enter your email address' }]}
          >
            <Input
              prefix={<MailOutlined className="site-form-item-icon" />}
              placeholder="Email address"
              autoFocus
            />
          </Form.Item>

          {error && <Alert message={error} type="error" showIcon className="login-alert" />}

          <Form.Item>
            <Button type="primary" htmlType="submit" className="login-form-button" loading={loading} block>
              SUBMIT
            </Button>
          </Form.Item>

          <div className="login-form-extras">
            <Link onClick={gotoLogin}>Back to Login</Link>
          </div>
        </Form>
      )}
    </div>
  );
};

export default connect(() => ({}), () => ({}))(withRouter(ForgotPassword));